/**
 * These are the profile permissions.
 */
/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */
export const profilePermissions = {
  DeptmentAndGroup: {
    Read: "profileDeptmentAndGroupCanRead"
  }
};
